import { HttpService, VisibaApiPromise } from '@services/http.service';
import { Singleton } from '@visiba/instantiation';
import { ParameterHandler } from '@visiba/std';
import { ApiBaseClient } from './_api_client_base';
import { ReceptionVisitInput } from './generated/models';

@Singleton()
export class RecentReceptionsApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('Receptions');
	}

	public async getRecentlyVisited(count: number): VisibaApiPromise<ReceptionVisitInput[]> {
		const parameterHandler = new ParameterHandler();
		parameterHandler.append({
			count,
		});

		return this.httpService.get(`${this.getBaseUri()}/RecentlyVisited${parameterHandler.getString()}`);
	}

	public async postToRecentlyVisited(receptionId: number): VisibaApiPromise<void> {
		return this.httpService.post(`${this.getBaseUri()}/RecentlyVisited`, { receptionId });
	}
}
